export enum EvaluationState
{
    RECOMENDADA = 1,
    RECOMENDADACONCONDICION = 2,
    NORECOMENDADA = 3
}